import { pipe } from 'ramda';
import { Category, CategoryId } from 'api/timesheets/categories';
import { Loaded, Updating } from 'core/state';
import { CategoriesStore, from, to } from './core';

export const updating = (next: Category) =>
  pipe(
    from,
    (store: CategoriesStore): CategoriesStore => {
      const { byId, ids, creating } = store;

      const { [next.id]: entry } = byId;
      const category = entry?.[1];

      if (category == null) {
        return store;
      }

      return {
        byId: { ...byId, [next.id]: Updating(next, category) },
        ids,
        creating,
      };
    },
    to,
  );
export const updated = (next: Category) =>
  pipe(
    from,
    (store: CategoriesStore): CategoriesStore => {
      const { byId, ids, creating } = store;

      const { [next.id]: entry } = byId;
      const category = entry?.[1];

      if (category == null) {
        return store;
      }

      return {
        byId: { ...byId, [next.id]: Loaded(next) },
        ids,
        creating,
      };
    },
    to,
  );

export const reverted = (id: CategoryId) =>
  pipe(
    from,
    (store: CategoriesStore): CategoriesStore => {
      const { byId, ids, creating } = store;

      const { [id]: entry } = byId;

      if (entry?.[0] !== 'updating') {
        return store;
      }

      return {
        byId: { ...byId, [id]: Loaded(entry[2]) },
        ids,
        creating,
      };
    },
    to,
  );
